<template>
	<div class="section-look">
		<v-layout wrap>
			<v-flex class="w-50">
				<div>
					<img 
						src=""
						class="image-look">
				</div>
			</v-flex>
			<v-flex class="section-text w-50">
				<div class="wrapper-title mb-3">
					<img src="" alt="car" height="30px" class="image-desktop">
					<span class="title">MIRA TODO LO QUE TENEMOS PARA TI</span>
				</div>
				<v-layout wrap class="wrapper-mobile">
					<v-flex class="pa-2 w-50">
						<div class="wrapper-text">
							<p class="center text-green">Tus distribuidores serán parte del trato</p>
							<p class="center">Ahora tus distribuidores serán tus socios de negocio, 
								ayúdalos a solicitar pedidos más rápido y fidelízalo</p>
						</div>
					</v-flex>
					<v-flex class="pa-2 w-50">
						<div class="wrapper-text">
							<p class="center text-green">+ rápido = más ventas</p>
							<p class="center">Que pedir productos no sea un problema, ayuda a tus distribuidores a
								 mejorar su experiencia en nuestra plataforma de pedidos</p>
						</div>
					</v-flex>
					<v-flex class="pa-2 w-50">
						<div class="wrapper-text">
							<p class="center text-green">Distribuir tus productos será toda una experiencia</p>
							<p>Entregar pedidos será cada vez más fácil gracias a 
								nuestro generador de rutas</p>
						</div>
					</v-flex>
					<v-flex class="pa-2 w-50">
						<div class="wrapper-text">
							<p class="center text-green">Tus clientes amarán haberte conocido</p>
							<p class="center">Generales una experiencia de impacto a través de nuestra app móvil para iOS y 
								Android. Fideliza a tus clientes creando promociones que se ajusten a 
								tus precios y a tu rubro.</p>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
export default {
	name: 'section-look',
};
</script>
<style lang="scss" scoped>
	.section-look {
		font-family: font(lato-regular);
		font-size: 13px;

		.section-text {
			padding: 70px 7% 0px 40px;

			@media (max-width: 936px) {
				padding: 70px 0 70px 0;
				order: -1;
			}
		}

		.title {
			color: map-get($colors, green-dark);
			margin-left: 16px;
			font-size: 20px;
			font-weight: 600;

			@media (max-width: 936px) {
				font-size: 16px !important;
			}
		}

		.wrapper-title {
			border-bottom: 2px solid map-get($colors, green-link);
			padding-bottom: 14px;
			
			@media (max-width: 936px) {
				text-align: center;
			}
		}

		.wrapper-text {
			border-radius: 9px;
			box-shadow: 0 2px 19px 0 rgba(0, 0, 0, 0.09);
			height: 260px;
			padding: 15px;

			@media (max-width: 936px) {
				height: 220px;
			}
		}

		.center {
			text-align: center;
		}

		.text-green {
			color: map-get($colors, title-green);
			font-weight: 600;
		}

		.w-50 {
			width: 50%;

			@media (max-width: 936px) {
				width: 100%;
			}
		}

		.image-desktop {
			@media (max-width: 936px) {
				display: none;
			}
		}

		.wrapper-mobile {
			@media (max-width: 936px) {
				padding: 0 15px;
			}
		}
	}

	.image-look {
		height: 684px;
		max-width: 100%;

		@media (max-width: 936px) {
			height: 348px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-look.vue